import {FC} from 'react';

import MarketPositionsForm from './components/market-position/marketPositionsForm';
import CreateMarketPositionsProvider from './providers/createMarketPositionsProvider';

/**
 * Create market positions page
 * @returns {JSX.Element}
 */
const CreateMarketPositionsPage: FC = () => {
  return (
    <CreateMarketPositionsProvider>
      <MarketPositionsForm />
    </CreateMarketPositionsProvider>
  );
};

export default CreateMarketPositionsPage;
